import React, { createContext, useContext, useEffect, useState } from 'react';
import { gql, useQuery } from '@apollo/client';

const GET_ACCOUNT_CONTEXT = gql`
  query GetAccountContext {
    account {
      id
      instantSearch
      searchLimit
      searchPartial
      anyWord
      onlyVerifiedWhatsappCampaigns
      whatsappProvider
      plugchatConnected
    }
  }
`;

const AccountContext = createContext();

export const useAccount = () => {
  const context = useContext(AccountContext);
  if (!context) {
    throw new Error('useAccount must be used within an AccountProvider');
  }
  return context;
};

export const AccountProvider = ({ children }) => {
  const { data, loading } = useQuery(GET_ACCOUNT_CONTEXT, {
    fetchPolicy: 'cache-and-network' 
  });
  
  const [accountSettings, setAccountSettings] = useState({
    instantSearch: true, // valor padrão
  });

  useEffect(() => {
    if (data?.account) {
      setAccountSettings({
        instantSearch: data.account.instantSearch ?? true, // usa true como padrão se não definido
        searchLimit: data.account.searchLimit || 20,
        searchPartial: data.account.searchPartial || false,
        anyWord: data.account.anyWord || false,
        onlyVerifiedWhatsappCampaigns: data.account.onlyVerifiedWhatsappCampaigns || false,
      });
    }
  }, [data]);

  const value = {
    account: data?.account,
    accountSettings,
    accountData: data?.account,
    loading,
  };

  return (
    <AccountContext.Provider value={value}>
      {children}
    </AccountContext.Provider>
  );
};